import axios from 'axios'

const upload = ({ contentType, url }, file, source, onUploadProgress) =>
  axios.put(url, file, {
    cancelToken: source.token,
    headers: { 'Content-Type': contentType },
    onUploadProgress,
  })

export default upload
